export const TextConsultationIcon = ({
  customClassName = '',
  ...props
}: {
  customClassName?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={customClassName} {...props}>
      <path
        d="M4.33607 7.47266C2.5107 7.47266 1.00002 8.99165 1.00002 10.8297V30.9436C0.996629 31.5608 1.49082 32.064 2.10383 32.0674C2.40341 32.0691 2.69093 31.9487 2.90107 31.7337L7.01315 27.5931H26.5288C28.3541 27.5931 29.8648 26.0741 29.8648 24.236V10.8297C29.8648 8.99165 28.3541 7.47266 26.5288 7.47266H4.33607ZM8.77548 14.1802H15.4367C16.0497 14.1669 16.5573 14.6564 16.5706 15.2736C16.5838 15.8908 16.0976 16.402 15.4847 16.4153C15.4687 16.4157 15.4527 16.4157 15.4367 16.4153H8.77548C8.16252 16.402 7.67635 15.8908 7.68959 15.2736C7.70242 14.6752 8.18115 14.1931 8.77548 14.1802ZM8.66059 18.6504C8.69886 18.6484 8.73721 18.6484 8.77548 18.6504H22.0893C22.7023 18.6366 23.2104 19.1257 23.2241 19.7429C23.2379 20.3601 22.7521 20.8717 22.1392 20.8855C22.1226 20.8859 22.106 20.8859 22.0893 20.8855H8.77548C8.16182 20.9038 7.64967 20.4176 7.63157 19.7997C7.61404 19.2011 8.06749 18.6947 8.66059 18.6504Z"
        fill="currentColor"
      />
      <path
        d="M8.7755 3.00001C8.1624 2.99794 7.66368 3.49666 7.66158 4.11397C7.65948 4.73141 7.66156 5.23567 7.66156 5.23567H9.09999H27.1C28.9 5.23567 32.084 6.35763 32.084 10.7031L32.084 20.9711H33.0967C33.7075 21.023 34.2445 20.5666 34.2961 19.9514C34.3013 19.8888 34.3013 19.8259 34.2961 19.7634V6.35763C34.2961 4.51962 32.7952 3.00001 30.9698 3.00001H8.7755Z"
        fill="currentColor"
      />
    </svg>
  )
}
